/// <reference types="sharepoint" />
import { Injectable, Inject, NgZone } from "@angular/core";
import { Window } from "selenium-webdriver";
import { BaseTranslation } from 'src/core/translation/model/translation.base';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { Language } from 'src/core/utility/enums/enums';


@Injectable()
export class LanguageSwitcherService extends  BaseTranslation {

    PagesList:string;
    currentLanguage:string;
    constructor(translate: TranslateService,ngZone:NgZone) { 
  
     super(translate,ngZone) 
       
       this.currentLanguage = Language[_spPageContextInfo.currentLanguage];
       
    }
    
    public LanguageSwitcher(selectedLanguage,onRedirect:()=>void) {

        this.translate.getTranslation(this.translate.defaultLang).subscribe((res) => {
            
            this.PagesList  =  this.translate.instant('language-switcher.PagesList' + selectedLanguage);

            SP.SOD.executeFunc('sp.js', 'SP.ClientContext', () => {

                // redirect to arabic page 
               this.checkPageExist(window.location.pathname.substring(window.location.pathname.lastIndexOf("/") + 1).replace('.aspx',''), _spPageContextInfo.webAbsoluteUrl.replace('/'+this.currentLanguage, '/'+selectedLanguage),this.PagesList).subscribe({
                   next: (res) => {
                       onRedirect();
                       if(res)
                           window.location.href = window.location.href.replace('/'+this.currentLanguage+'/', '/'+selectedLanguage+'/');
                       else
                           window.location.href= _spPageContextInfo.siteAbsoluteUrl+'/'+selectedLanguage;
                       
                   }, error: (res) => {
                       onRedirect();
                       window.location.href= _spPageContextInfo.siteAbsoluteUrl+'/'+selectedLanguage;
                   }
               });
             });
       
           });

        

    }

    
    private checkPageExist(pageName: string, siteUrl: string,listname:string): Subject<boolean> {
        let result = new Subject<boolean>();

        let context: SP.ClientContext = new SP.ClientContext(siteUrl);
        let list: SP.List = context.get_web().get_lists().getByTitle(listname);
        let spCamlQuery: SP.CamlQuery = new SP.CamlQuery();
        spCamlQuery.set_viewXml('<View><Query><Where><Eq><FieldRef Name="FileLeafRef" /><Value Type="File">' + pageName+ '.aspx' + '</Value></Eq></Where></Query></View>');
        let items = list.getItems(spCamlQuery);
        context.load(items);
        context.executeQueryAsync(
            (sender, args) => {

                let enumerator = items.getEnumerator();
                if (enumerator.moveNext()) {
                    result.next(true);
                    result.complete();
                }
                else
                {
                    result.next(false);
                    result.complete();
                }

            }, (sender, args) => {
                result.error(args);
            }
        );
        return result;
    }



}